// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3Hp7D","tab":"styles_tab__aQhmx","activeTab":"styles_activeTab__OSLQf","tabs":"styles_tabs__2bQOv"};